<template>
    <div class="d-flex flex-fill flex-column pa-2">
        <fe-grid
            :columnDefs="colDefs"
            :rowData="items"
            :showAddRowBtn="false"
            displayDensity="small"
            ref="grid"
            domLayout="autoHeight"
            @rowDoubleClicked="editIncident"
        />
        <fe-crud ref="crud" :config="crudConfig" @read="postRead"/>
    </div>
</template>

<script>
    import {mapState} from "vuex"
    import IFrameRenderer from '@/components/common/IFrameRenderer'

    export default {
        name: "OpenIncidents",

        components: {
            IFrameRenderer
        },

        props: {
            rowData: {
                type: Array,
                default: []
            }
        },

        data() {
            return {
                items: [],
                colDefs:  [{
                    headerName: 'Open Since',
                    field: 'incident_created',
                    valueFormatter: v => this.$dayjs(v.data.incident_created).format('YYYY-MM-DD'),
                    sortable: true,
                    width: 150
                }, {
                    headerName: 'Date',
                    field: 'incident_datetime',
                    valueFormatter: v => this.$dayjs(v.data.incident_datetime).format('YYYY-MM-DD'),
                    sortable: true,
                    width: 150
                }, {
                    headerName: 'Incident Type & Code',
                    field: 'incident_behavior_display_name',
                    sortable: true,
                    flex: 1
                }, {
                    headerName: "Student",
                    field: "student_full_name",
                    sortable: true,
                    width: 200,
                    flex: 1
                }, {
                    headerName: "School",
                    field: "school_name",
                    sortable: true,
                    flex: 1
                }, {
                    headerName: "Grade",
                    field: "grade_desc",
                    sortable: true,
                    width: 100
                }, {
                    headerName: 'Responder',
                    field: 'responder_user_full_name',
                    sortable: true,
                    flex: 1
                }]
            }
        },

        computed: {
            ...mapState('global', ['sessionUser', 'currentYear']),

            crudConfig() {
                return _.cloneDeep(this.$models.studentIncidentList)
            }
        },

        mounted() {
            if (this.rowData.length) {
                this.items = this.rowData
            } else {
                this.$refs.crud.read({
                    open: 1
                })
            }
        },

        methods: {
            editIncident(incident) {
                const identifier = new Date().getMilliseconds()
                let win = {
                    name: 'Edit Incident',
                    component: 'i-frame-renderer',
                    attrs: {
                        app: 'incident_creation',
                        cfg: {
                            params: {
                                user_id: this.sessionUser.user.id,
                                incident_id: incident.data.incident_id
                            },
                            identifier
                        }
                    },
                    events: {
                        close: () => {
                            window.removeEventListener('message', onMessage)
                            if (this.rowData.length) {
                                this.items = this.rowData
                            } else {
                                this.$refs.crud.read({
                                    open: 1
                                })
                            }
                        },
                    },
                }
                // The incident entry form (rendered inside IFrameRenderer's iframe) posts
                // {identifier, action: 'close'} back via window.parent.postMessage when the user closes it.
                const onMessage = (e) => {
                    if (!e.origin.endsWith('.educlimber.dev') && !e.origin.endsWith('.educlimber.app') && !e.origin.endsWith('.educlimber.com') && e.origin !== window.location.origin) {
                        return
                    }

                    let eventData
                    try {
                        eventData = (typeof e.data === 'string' || e.data instanceof String) ? JSON.parse(e.data) : e.data
                    } catch (err) {
                        return
                    }

                    // loose equality: identifier round-trips through the iframe's URL query string,
                    // so it comes back as a string even though it was set here as a number
                    if (eventData?.identifier == identifier && eventData?.action === 'close') {
                        window.removeEventListener('message', onMessage)
                        this.$refs.crud.read({ open: 1 })
                        this.$emit('reload')
                        this.$store.commit('global/removeDockedWindow', win)
                        this.$snackbars.$emit('new', {text: 'Successfully deleted incident', usage: 'success'})
                    }
                }
                window.addEventListener('message', onMessage)

                this.$store.commit('global/addDockableWindow', win)
            },
            postRead(data) {
                this.items = this.$_.uniqWith(data, (a,b) => {
                    return a.incident_id + ':' + a.student_id === b.incident_id + ':' + b.student_id
                })
            }
        }
    }
</script>

<style scoped>

</style>
